/* ==========================================================================
   ButtonRxjs > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ButtonRxjs',
    init: true,
    start: true,
    events: true,
    css: {
        hidden: 'is-hidden',
        disable: 'is-disabled',
        loading: 'is-loading'
    }
};

module.exports = () => config;
